import { imagePrefix } from '@/constants';
import React from 'react';
import styles from './index.less';

interface IDetailTitleProps {
  title: string;
}

const DetailTitle: React.FC<IDetailTitleProps> = ({ title }) => {
  return (
    <div className={styles.index}>
      <div
        className={styles.left}
      >
        <div
          className={styles.logo}
        >
          <img
            src={imagePrefix('title-logo.png')}
            alt=""
          />
        </div>
        <div
          className={styles.title}
        >
          {title}
        </div>
      </div>
    </div>
  );
};

export default DetailTitle;